// Site Specific Stuff Here

var BROWNEFAMILY = BROWNEFAMILY || {};


BROWNEFAMILY.resizer = (function() {
	// var footerHeight = parseInt($('.site-footer-update').height());
	var windowHeight = parseInt($(window).height());
	var windowWidth = parseInt($(window).width());
	var navHeight = parseInt($('nav.row.custom-nav').height())
	
	var origWindowHeight;

	console.log(windowHeight);
	console.log(windowWidth);
	console.log(windowWidth);
	
	$(window).on('load', function() {
	  windowHeight = parseInt($(window).height());
	  windowWidth = parseInt($(window).width());
	  origWindowHeight = windowHeight;
	
	  if(windowWidth >= 767.98) {
		  //{"background-color": "yellow", "font-size": "200%"}
	    $('.home-image').css('margin-top', 0);
	    $('.home-image').css('height', windowHeight);
	    $('.home-body').css('height', windowHeight);
	  } else {
	    $('.home-body').css('height', '100%');
	    $('.home-image').removeAttr('margin-top');
	    $('.home-image').css('margin-top', navHeight);
	    $('.home-image').css('height', windowWidth);
	  }
	});
	
	$(window).resize(function() {
		windowHeight = parseInt($(window).height());
	  windowWidth = parseInt($(window).width());
	  if(windowWidth >= 767.98) {
	    $('.home-image').css('margin-top', 0);
	    $('.home-image').css('height', windowHeight);
	    $('.home-body').css('height', windowHeight);
	  } else {
	    $('.home-image').removeAttr('margin-top');
	    $('.home-image').css('margin-top', navHeight);
	    $('.home-image').css('height', windowWidth);
	    $('.home-body').css('height', '100%');
	  }
	});
})();




